import FILTER_FIELDS from './FILTER_FIELDS';

const { hostname } = window.location;
const IsAzAccount = hostname?.split('.')[0] === 'az';
const IsVaAccount = hostname?.split('.')[0] === 'va';

const RETAILERS_QUICK_QUERY_OPTIONS = {
  OPTION_CURRENT_TOBACCO: 'Retailers selling tobacco',
  OPTION_CURRENT_ALCOHOL: 'Retailers selling alcohol',
  OPTION_CURRENT_NEAR_SCHOOL: 'Retailers near schools',
  ...(IsVaAccount ? { OPTION_CURRENT_HEMP: 'Retailers selling hemp-derived cannabis products' } : {}),
  ...(IsVaAccount ? { OPTION_CURRENT_RETAILER_LOTTERY_TICKETS: 'Retailers selling lottery tickets' } : {}),
  ...(IsVaAccount ? { OPTION_CURRENT_RETAILER_GAMING_MACHINES: 'Retailers with gaming machines' } : {}),
  OPTION_CURRENT_NO_VISIT_TYPE: `${
    IsAzAccount ? 'Retailers with no inspection,' : 'Retailers with no visit types,'
  } within time period:`,

  OPTION_CURRENT_MORE_ENFORCEMENT_VIOLATION:
    'Retailers with \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 or more Enforcement violations',

  OPTION_CURRENT_LAST_YEAR_VIOLATIONS:
    'Retailers with \xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0 or more sale to minor violations within one year of each other',
};

if (IsAzAccount) {
  RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_MORE_ENFORCEMENT_VIOLATION =
    RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_MORE_ENFORCEMENT_VIOLATION?.replace('Enforcement', 'Inspection');
}
const RETAILERS_QUICK_QUERY_MAPPING = {
  [FILTER_FIELDS.TOBACCO]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_TOBACCO,
  [FILTER_FIELDS.ALCOHOL]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_ALCOHOL,
  [FILTER_FIELDS.NEAR_SCHOOL]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_NEAR_SCHOOL,
  [FILTER_FIELDS.SELLS_HEMP]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_HEMP,
  [FILTER_FIELDS.SELLS_TICKETS]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_RETAILER_LOTTERY_TICKETS,
  [FILTER_FIELDS.HAS_GAMING_MACHINES]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_RETAILER_GAMING_MACHINES,
  [FILTER_FIELDS.NO_VISIT_TYPE]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_NO_VISIT_TYPE,
  [FILTER_FIELDS.VIOLATION_COUNT_GRT]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_MORE_ENFORCEMENT_VIOLATION,
  [FILTER_FIELDS.MINOR_VIOLATION_COUNT_GRT]: RETAILERS_QUICK_QUERY_OPTIONS.OPTION_CURRENT_LAST_YEAR_VIOLATIONS,
};

const ATCC_OPTIONS = {
  OPTION_IS_ATCC: 'Retailers with ATCC license',
  OPTION_ATCC_CERTAIN_YEAR: 'Retailers with ATCC license year',
  OPTION_NOT_ATCC: 'Retailers without ATCC license',
};

const ATCC_OPTIONS_LABELS = {
  t: 'Retailers with ATCC license',
  OPTION_ATCC_CERTAIN_YEAR: 'Retailers with ATCC license year',
  f: 'Retailers without ATCC license',
};

const SYNAR_OPTIONS = {
  OPTION_IS_SYNAR: 'Retailers with Synar flag',
  OPTION_SYNAR_CERTAIN_YEAR: 'Retailers with Synar flag by year',
  OPTION_NOT_SYNAR: 'Retailers with Synar flag unknown',
};

const SYNAR_OPTIONS_LABELS = {
  t: 'Retailers with Synar flag',
  OPTION_SYNAR_CERTAIN_YEAR: 'Retailers with Synar flag by year',
  f: 'Retailers with Synar flag unknown',
};

export default {
  RETAILERS_QUICK_QUERY_OPTIONS,
  RETAILERS_QUICK_QUERY_MAPPING,
  ATCC_OPTIONS,
  ATCC_OPTIONS_LABELS,
  SYNAR_OPTIONS,
  SYNAR_OPTIONS_LABELS,
};
